<!-- data table showing leave requests that were submitted -->
<div *ngIf="visible">
  <app-data-table [columns]="tableColumns" [value]="emergencyContacts" [sortField]="DefaultSortField"
                  [rightCaptionTemplate]="contactRightCaption" [disableSearch]="true">

    <ng-template #contactRightCaption pTemplate="caption">
      <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Emergency Contact"
              pTooltip="Make New Emergency Contact" tooltipPosition="top"
              (click)="onClickAddEmergencyContact()">
      </button>
    </ng-template>

    <ng-template #contactAction let-row="row">
      <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update" tooltipPosition="top" (click)="onClickEditEmergencyContact(row)">
      </button>
      <button pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete" tooltipPosition="top" (click)="onClickDeleteEmergencyContact(row)">
      </button>
    </ng-template>
  </app-data-table>
</div>

<p-confirmDialog></p-confirmDialog>

<!-- dialog for new Emergency Contact or editing an existing leave request -->
<p-dialog *ngIf="emergencyContactToEdit&&displayDialog"
          [(visible)]="displayDialog" header="Emergency Contact" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="DialogStyle460" [contentStyle]="{'overflow-y':'auto'}">
  <form class="p-grid" #dialogForm="ngForm">

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Relationship*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="relationshipType" [placeholder]="Validation.DropdownPlaceholder"
                  [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="relationshipTypeDropDown"
                  [(ngModel)]="emergencyContactToEdit.relationType" required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Contact Type*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="contactType" [placeholder]="Validation.DropdownPlaceholder"
                  [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="contactTypeDropDown"
                  [(ngModel)]="emergencyContactToEdit.type" required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>First Name*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="firstName" type="text" [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="emergencyContactToEdit.firstName" required/>
      <div *ngIf="emergencyContactToEdit?.firstName?.length >= Validation.TextMaxLength" class="alert alert-danger" style="width:225px;">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Last Name*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="lastName" type="text" [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="emergencyContactToEdit.lastName" required/>
      <div *ngIf="emergencyContactToEdit?.lastName?.length >= Validation.TextMaxLength" class="alert alert-danger" style="width:225px;">
        {{Validation.MaxNumOfCharsExceeded}}
      </div>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Email Type*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="emailType" [placeholder]="Validation.DropdownPlaceholder"
                  [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="emailTypeDropDown"
                  [(ngModel)]="emergencyContactToEdit.emailType" required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Email*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <input pInputText name="email" type="email" [pattern]="RegExpEmail" [maxlength]="Validation.AddrMaxLength"
             [(ngModel)]="emergencyContactToEdit.emailAddr" required>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Phone Type*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="phoneType" [placeholder]="Validation.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="phoneTypeDropDown"
                  [(ngModel)]="emergencyContactToEdit.phoneType" required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Phone #*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <app-international-phone-number name="phoneNumber" [(ngModel)]="emergencyContactToEdit.phoneNumber" required></app-international-phone-number>
    </div>


    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Company</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8 mobile-scroll">
      <input pInputText name="company" type="text" [maxlength]="Validation.TextMaxLength"
             [(ngModel)]="emergencyContactToEdit.company"/>
    </div>

  </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <!-- disable it until all required field inclduing chargeCodeId are selected -->
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="displayDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add"
              (click)="onClickSaveEmergencyContact(emergencyContactToEdit)" [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>
